import { render, staticRenderFns } from "./ResponseItem.vue?vue&type=template&id=2aa0f981&scoped=true&"
import script from "./ResponseItem.vue?vue&type=script&lang=js&"
export * from "./ResponseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0f981",
  null
  
)

export default component.exports